import { useState } from "react";
import { InputRadioOp1Props } from "./InputRadioOp1.type";

const INPUT_COLOR_ERROR = "red";
const INPUT_COLOR = "#D0D0D0";

export default function InputRadioOp1({
  fieldName,
  label,
  register,
  required,
  error,
  onChange,
  option1,
  option2,
  labelForComment,
  rows,
  getValues,
  setValue,
  readOnly,
}: InputRadioOp1Props) {
  const [showTextArea, setShowTextArea] = useState(
    !!getValues?.(`${fieldName}_comment`),
  );

  return (
    <>
      <div className="w-full flex flex-col align-middle md:flex-row md:justify-between">
        <label className="mb-3">{label}</label>
        <div className="mr-3">
          <label className="sm:mx-3">
            <input
              disabled={readOnly}
              type="radio"
              className="mx-1 sm:mx-3 text-red-500"
              {...register(fieldName, {
                required,
              })}
              checked={showTextArea}
              value={option1}
              onClick={() => setShowTextArea(true)}
            />
            {option1 ? option1 : undefined}
          </label>
          <label className="sm:mx-3">
            <input
              type="radio"
              disabled={readOnly}
              className="mx-1 sm:mx-3 text-red-500"
              {...register(fieldName, {
                required,
              })}
              value={option2}
              onClick={() => {
                setValue(`${fieldName}_comment`, "");
                setShowTextArea(false);
              }}
            />
            {option2 ? option2 : undefined}
          </label>
        </div>
      </div>
      {showTextArea ? (
        <textarea
          className="rounded w-full mt-2"
          disabled={readOnly}
          {...register(`${fieldName}_comment`, {
            required,
            onChange: (e) => {
              onChange && onChange(e);
            },
          })}
          style={{
            borderColor: `${error ? INPUT_COLOR_ERROR : INPUT_COLOR}`,
          }}
          rows={rows}
          placeholder={labelForComment}
        ></textarea>
      ) : undefined}
      {/* ERRORS MESSAGE */}
      {error?.message && (
        <span style={{ color: INPUT_COLOR_ERROR }}>{error?.message}</span>
      )}
      {error?.type === "required" && (
        <span style={{ color: INPUT_COLOR_ERROR }}>Campo Obligatorio*</span>
      )}
    </>
  );
}
